import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityActionPlan } from '@api/data-security';

export const getCoreDataSecurityActionPlanSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityActionPlan',
	receive: true,
	request: true,
	requestHandler: getDataSecurityActionPlan,
	retainDataOnRequest: true
});
